import React from "react";
import "./QuoteHero.css";

const QuoteHero = () => {
  return (
    <section className="quote-hero-section no-print">
      <div className="hero-content">
        <h1 className="hero-title">출판 견적서</h1>
      </div>
    </section>
  );
};

export default QuoteHero;
